import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { LogoHeader } from '../../../containers/Components/index';

class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> FAQ </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> What is virtual reality?
                    </h6>
                    <h6>
                      <strong>A: </strong> Virtual Reality (VR) is the use of computer technology to create a simulated environment. 
                      Unlike traditional user interfaces, VR places the user inside an experience. Instead of viewing a screen in 
                      front of them, users are immersed and able to interact with 3D worlds. By simulating as many senses as possible, 
                      such as vision, hearing, touch, even smell, the computer is transformed into a gatekeeper to this artificial world. 
                      The only limits to near-real VR experiences are the availability of content and cheap computing power. 
                    </h6>

                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> What is augmented reality?
                    </h6>
                    <h6>
                      <strong>A: </strong> Augmented reality (AR) is an interactive experience of a real-world environment whereby 
                      the objects that reside in the real-world are "augmented" by computer-generated perceptual information, 
                      sometimes across multiple sensory modalities, including visual, auditory, haptic, somatosensory, 
                      and olfactory. The overlaid sensory information can be constructive (i.e. additive to the natural environment) 
                      or destructive (i.e. masking of the natural environment) and is seamlessly interwoven with the physical world 
                      such that it is perceived as an immersive aspect of the real environment. In this way, augmented reality alters 
                      one’s ongoing perception of a real world environment, whereas virtual reality completely replaces the user's 
                      real world environment with a simulated one.
                    </h6>

                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> What is 360 experience?
                    </h6>
                    <h6>
                      <strong>A: </strong> 360-degree experience (or 360-degree virtual reality) is an audiovisual simulation 
                      of an altered, augmented or substituted environment that surrounds the user, allowing them to look around 
                      them in all directions, just as they can in real life.
                    </h6>

                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> What are virtual reality headsets and how can I get one?
                    </h6>
                    <h6>
                      <strong>A: </strong> The main ingredient in virtual reality is a persistent 3D visual representation 
                      of the experience that conveys a sense of depth. To create this depth, virtual reality hardware systems 
                      employ a 3D display, also known as a stereoscopic display or head mounted display (HMD). Please refer to our 
                      <a target="_blank" rel="noopener noreferrer" href="http://www.icomputinglabs.in/blog/index.php/total-immersion-experience-vr-headsets/"> BLOG</a> to 
                      find the best VR headset for you. 
                    </h6>

                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> Is there a guide for the app?
                    </h6>
                    <h6>
                      <strong>A: </strong> Yes. Please find the app guide <a href="/appguide">here</a>.
                    </h6>

                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> Is there a guide for using the platform?
                    </h6>
                    <h6>
                      <strong>A:  </strong> We are still preparing it. It will be available soon.
                    </h6>
                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> How do I start using the app?
                    </h6>
                    <h6>
                      <strong>A: </strong> You can start using the app by downloading it from the Android Play Store Link. 
                      You will need a VR headset for the total immersion experience.
                    </h6>

                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> Why does Google Play say the the app is not compatible with your device?
                    </h6>
                    <h6>
                      <strong>A: </strong> There seem to be 3 criteria for the app being compatible with your mobile: 
                      <br />
                      1. Android version above 4.3 
                      <br />
                      2. The CPU processor in the mobile needs to be powerful enough to handle the graphics. 
                      We're using Unity Game Engine to build the app, which requires at a minimum a processor 
                      with ARMv7 + x86. The majority of mobiles have this, however if yours is slightly older, sadly it may not. 
                      <br />
                      3. Your mobile needs to have a gyroscope sensor. This is more specific for Google Cardboard 
                      and VR apps, as it allows for more accurate recognition of movement within 3D space. It stops 
                      the scene drifting and measures head movement when you have the VR headset on. Not all the 
                      older android phones have this sensor. 
                      <br />
                      If your device is not compatible, the likelihood is that your mobile is a slightly older 
                      model and does not have a gyroscope. This seems to be the most common reason in our experience.
                    </h6>
                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> How can I get the access code for the app?
                    </h6>
                    <h6>
                      <strong>A:  </strong> Once you register to our platform, your access code for the the app is created.
                      You can get it from your settings page. 
                    </h6>
                    <h6 className = "mt-5 pt-2 ">
                     <strong>Q: </strong> I want to make a custom XR experience for my business. Can you help us?
                    </h6>
                    <h6>
                      <strong>A: </strong> Yes, sure. Our team of artists, managers and developers are always 
                      ready to help you. Please read <a href="/customdev">this</a> to understand our custom development process. 
                    </h6>
                    <h6 className = "mt-5 pt-2 ">
                      <b />
                      <b />
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="1">
                  </Col>
                </Row>
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/views/Pages/FAQ/FAQ.js